class ThemeForm extends HTMLElement {
  inputs; valid; buttons; loader; form;

  static selectors = {
    inputs: "input-text,input-select,input-area,input-checkbox,input-password",
    submit: '[data-submit]',
    serverErrors: 'form-errors',
    serverSuccess: 'form-success',
    loader: 'theme-loader'
  }
  
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.inputs = this.querySelectorAll(ThemeForm.selectors.inputs);
    this.buttons = this.querySelectorAll(ThemeForm.selectors.submit);
    this.loader = this.querySelector(ThemeForm.selectors.loader);
    this.init();
  }

  init = () => {
    // Controlla se il server ha restituito errori o successo dalla pagina precedente
    // Utile per mostrare messaggi di feedback all'utente ancora in form
    if(this.querySelector(ThemeForm.selectors.serverErrors) != undefined){
      this.dispatchEvent(new CustomEvent(Utils.E_FORM_ERROR, { detail: 'server-error' }));
    }
    if(this.querySelector(ThemeForm.selectors.serverSuccess) != undefined){
      this.dispatchEvent(new CustomEvent(Utils.E_FORM_SUCCESS, { detail: 'server-success' }));
    }
    this.buttons.forEach(button => {
      button.addEventListener("click", (event) => {
        this.handleSubmit(event);
      });
    });
  }

  handleSubmit = (e) => {
    // Valida tutti gli input prima di inviare il form
    this.validate();
    if(this.valid){
      this.showLoader();
      // Se il form ha l'attributo ajax, invia via AJAX mantenendo l'utente sulla stessa pagina
      // Altrimenti fa un submit tradizionale che ricarica la pagina
      if(this.dataset.ajax !== undefined)
        this.ajaxSubmit();
      else
        this.form.submit();
    }
  }

  ajaxSubmit = () => {
    this.dispatchEvent(new CustomEvent(Utils.E_FORM_SUBMIT));
    axios.post(this.form.action, new FormData(this.form))
      .then(response => {
        this.dispatchEvent(new CustomEvent(Utils.E_FORM_SUCCESS, { detail: response }));
      })
      .catch(error => {
        this.dispatchEvent(new CustomEvent(Utils.E_FORM_ERROR, { detail: error }));
        Utils.errorHanlder(error);
      })
      .finally(() => {
        this.hideLoader();
        this.dispatchEvent(new CustomEvent(Utils.E_FORM_SENT));
        this.form.reset();
      });
  }

  validate = () => {
    let inputs = this.querySelectorAll(ThemeForm.selectors.inputs);
    this.valid = true;
    inputs.forEach(input => {
      const valid = input.validate() != Input.ISINVALID;
      this.valid = valid && this.valid;
    });
    return this.valid;
  }

  showLoader = () => {
    if(this.loader != undefined)
      this.loader.show();
  }

  hideLoader = () => {
    if(this.loader != undefined)
      this.loader.hide();
  }
}
if (!window.customElements.get("theme-form")) {
  window.customElements.define("theme-form", ThemeForm);
}

class Input extends HTMLElement {
  input; required; messages; message; valid; group; invalidFeedback; form;

  static ISVALID = 1;
  static ISINVALID = 2;
  static ISNORMAL = 3;
  static classes = {
    valid: "valid",
    invalid: "is-invalid",
    validated: "has-validation"
  }

  validators = {
    email: false,
    pattern: false,
    required: false,
    number: false,
    url: false,
    minLength: false,
    maxLength: false,
    equals: false,
    min: false,
    max: false,
    date: false,
    minDate: false,
    maxDate: false,
    minTime: false,
    maxTime: false
  };
  selectors = {
    input: "input",
    group: ".input-group",
    invalidFeedback: "[data-invalid]",
    validFeedback: "[data-valid]",
  };

  constructor() {
    super();
  }

  init = () => {
    this.form = this.closest('theme-form');
    this.valid = Input.ISNORMAL;
    this.input = this.querySelector(this.selectors.input);
    this.group = this.querySelector(this.selectors.group);
    this.invalidFeedback = this.querySelector(this.selectors.invalidFeedback);
    this.setEvents();
  }

  setEvents = () => { 
    // Recupera i definitori di validazione dai data attributes
    this.getMessages();
    this.getValidators();

    // Valida l'input quando l'utente abbandona il campo (blur)
    this.input.addEventListener("blur", () => {
      this.validate();
    });

    // Resetta lo stato di validazione quando l'utente torna al campo (focus)
    this.input.addEventListener("focus", () => {
      this.setValid(true);
    });
  }

  getMessages = () => {
    this.messages = this.dataset.messages;
    if (this.messages == undefined) {
      this.messages = window.formErrors;
    } else {
      this.messages = JSON.parse(this.messages);
    }
  }

  getValidators = () => {
    for (let key in this.validators) {
      if (this.dataset[key] !== undefined) {
        this.validators[key] = this.dataset[key];
      }
      if(key === "email"){
        this.validators[key] = this.input.type == 'email';
      } else if(key === "url"){
        this.validators[key] = this.input.type == 'url';
      } else if(key === "number"){
        this.validators[key] = this.input.type == 'number';
      } else if(key === "date"){
        this.validators[key] = this.input.type == 'date' || this.input.type == 'datetime-local' || this.input.type == 'month' || this.input.type == 'week';
      } else if(key === 'required'){
        this.validators[key] = this.input.required;
      }
    }
  }

  validate = () => {
    this.valid = Input.ISVALID;
    // Itera su tutti i validator configurati eseguendoli nel switch
    for (let key in this.validators) {
      if (this.validators[key] !== false) {
        switch (key) {
          case "email":
            this.validateEmail();
            break;
          case "pattern":
            this.validatePattern();
            break;
          case "required":
            this.validateRequired();
            break;
          case "number":
            this.validateNumber();
            break;
          case "url":
            this.validateUrl();
            break;
          case "minLength":
            this.validateMinLength();
            break;
          case "maxLength":
            this.validateMaxLength();
            break;
          case "equals":
            this.validateEquals();
            break;
          case "min":
            this.validateMin();
            break;
          case "max":
            this.validateMax();
            break;
          case 'date':
            this.validateDate();
            break;
          case 'time':
            this.validateTime();
            break;
          case 'minDate':
            this.validateMinDate();
            break;
          case 'maxDate':
            this.validateMaxDate();
            break;
          case 'minTime':
            this.validateMinTime();
            break;
          case 'maxTime':
            this.validateMaxTime();
            break;
        }
        // Interrompe la validazione non appena trova un errore
        if (this.valid == Input.ISINVALID) {
          break;
        }
      }
    }
    // Se il campo è vuoto e non è required, lo considera valido (non validato necessariamente)
    if(this.valid == Input.ISVALID && this.isEmpty() && this.validators.required == false){
      this.valid = Input.ISNORMAL;
    }
    this.setValid();
    return this.valid;
  }

  setValid = (valid = null) => {
    if(valid !== null)
      this.valid = valid;
    
    if(this.group != undefined){
      this.group.classList.add(Input.classes.validated);
    }

    if(this.valid === Input.ISVALID) {
      if(this.group != undefined){
        this.group.classList.remove(Input.classes.invalid);
        this.group.classList.add(Input.classes.valid);
      }
      if(this.invalidFeedback != undefined){
        this.invalidFeedback.textContent = "";
      }
    }
    else if(this.valid === Input.ISINVALID){
      if(this.group != undefined){
        this.group.classList.remove(Input.classes.valid);
        this.group.classList.add(Input.classes.invalid);
      }
      if(this.invalidFeedback != undefined){
        this.invalidFeedback.textContent = this.message;
      }
    }
    else {
      if(this.group != undefined){
        this.group.classList.remove(Input.classes.invalid);
        this.group.classList.remove(Input.classes.valid);
      }
      if(this.invalidFeedback != undefined){
        this.invalidFeedback.textContent = "";
      }
    }

  }

  validateServer = (message) => {
    this.valid = Input.ISINVALID;
    this.message = message;
    this.setValid();
  }

  validateEmail = () => {
    if (this.validators.email !== false && !this.isEmpty()){
      let email = new RegExp("^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$");
      if (!email.test(this.input.value)) {
        this.valid = InputText.ISINVALID;
        this.message = this.messages.email;
      } 
    }
  }

  validatePattern = () => {
    if (this.validators.pattern !== false && !this.isEmpty()) {
      let pattern = new RegExp(this.dataset.pattern);
      if (!pattern.test(this.input.value)) {
        this.valid = Input.ISINVALID;
        this.message = this.messages.pattern;
      }
    }
  }

  validateRequired = () => {
    if (this.validators.required !== false) {
      if (this.isEmpty()) {
        this.valid = Input.ISINVALID;
        this.message = this.messages.required;
      }
    }
  }

  validateNumber = () => {
    if (this.validators.number !== false && !this.isEmpty()) {
      if (isNaN(this.input.value)) {
        this.valid = Input.ISINVALID;
        this.message = this.messages.number;
      }
    }
  }

  validateUrl = () => {
    if (this.validators.url !== false && !this.isEmpty()) {
      let url = new RegExp("^(http|https)://");
      if (!url.test(this.input.value)) {
        this.valid = Input.ISINVALID;
        this.message = this.messages.url;
      }
    }
  }

  validateMinLength = () => {
    if (this.validators.minLength !== false && !this.isEmpty()) {
      let minLength = parseInt(this.validators.minLength);
      if (this.input.value.length < minLength) {
        this.valid = Input.ISINVALID;
        this.message = this.messages.minLength.replace("{{ length }}", minLength);
      }
    }
  }

  validateMaxLength = () => {
    if (this.validators.maxLength !== false && !this.isEmpty()) {
      let maxLength = parseInt(this.validators.maxLength);
      if (this.input.value.length > maxLength) {
        this.valid = Input.ISINVALID;
        this.message = this.messages.maxLength.replace("{{ length }}", maxLength);
      }
    }
  }

  validateEquals = () => {
    if (this.validators.equals !== false && !this.isEmpty()) {
      let equals = document.querySelector(this.validators.equals);
      if (equals && this.input.value !== equals.value) {
        this.valid = Input.ISINVALID;
        this.message = this.messages.equals;
      }
    }
  }

  validateMin = () => {
    if (this.validators.min !== false && !this.isEmpty()) {
      let min = parseFloat(this.validators.min);
      if (isNaN(this.input.value) || parseFloat(this.input.value) < min) {
        this.valid = Input.ISINVALID;
        this.message = this.messages.min.replace("{{ min }}", min);
      }
    }
  }

  validateMax = () => {
    if (this.validators.max !== false && !this.isEmpty()) {
      let max = parseFloat(this.validators.max);
      if (isNaN(this.input.value) || parseFloat(this.input.value) > max) {
        this.valid = Input.ISINVALID;
        this.message = this.messages.max.replace("{{ max }}", max);
      }
    }
  }

  validateDate = () => {
    if (this.validators.date !== false && !this.isEmpty()) {
      let date = this.input.type == 'week' ? Utils.getDateOfWeek(this.input.value) : new Date(this.input.value);
      if (isNaN(date.getTime())) {
        this.valid = Input.ISINVALID;
        this.message = this.messages.date;
      }
    }
  }

  validateTime = () => {
    if (this.validators.time !== false && !this.isEmpty()) {
      let time = Utils.dateFromTime(this.input.value);
      if (isNaN(time.getTime())) {
        this.valid = Input.ISINVALID;
        this.message = this.messages.time;
      }
    }
  }

  validateMinDate = () => {
    if (this.validators.minDate !== false && !this.isEmpty()) {
      let minDate = new Date(this.validators.minDate);
      let date = new Date(this.input.value);
      if (date < minDate) {
        this.valid = Input.ISINVALID;
        this.message = this.messages.minDate.replace("{{ date }}", minDate.toLocaleDateString());
      }
    }
  }

  validateMaxDate = () => {
    if (this.validators.maxDate !== false && !this.isEmpty()) {
      let maxDate = new Date(this.validators.maxDate);
      let date = new Date(this.input.value);
      if (date > maxDate) {
        this.valid = Input.ISINVALID;
        this.message = this.messages.maxDate.replace("{{ date }}", maxDate.toLocaleDateString());
      }
    }
  }

  validateMinTime = () => {
    if (this.validators.minTime !== false && !this.isEmpty()) {
      let minTime = Utils.dateFromTime(this.validators.minTime);
      let time = Utils.dateFromTime(this.input.value);
      if (time.getTime() < minTime.getTime()) {
        this.valid = Input.ISINVALID;
        this.message = this.messages.minTime.replace("{{ time }}", minTime.toLocaleTimeString());
      }
    }
  }

  validateMaxTime = () => {
    if (this.validators.maxTime !== false && !this.isEmpty()) {
      let maxTime = Utils.dateFromTime(this.validators.maxTime);
      let time = Utils.dateFromTime(this.input.value);
      if (time.getTime() > maxTime.getTime()) {
        this.valid = Input.ISINVALID;
        this.message = this.messages.maxTime.replace("{{ time }}", maxTime.toLocaleTimeString());
      }
    }
  }

  isEmpty = () => {
    return this.input.value.trim() === "";
  }
}

class InputText extends Input {
  
  constructor() {
    super();
    this.init();
  }
}
if (!window.customElements.get("input-text")) {
  window.customElements.define("input-text", InputText);
}

class InputSelect extends Input {

  constructor() {
    super();
    this.selectors.input = "select";
    this.init();
  }

  setEvents = () => { 
    this.getMessages();
    this.getValidators();
    if(this.dataset.selected != undefined) {
      this.input.value = this.dataset.selected;
    }
    this.input.addEventListener("change", () => {
      this.validate();
      if(this.dataset.autosubmit != undefined) {
        this.form.handleSubmit();
      }
    });
  }
  
}
if (!window.customElements.get("input-select")) {
  window.customElements.define("input-select", InputSelect);
}


class InputArea extends Input {

  constructor() {
    super();
    this.selectors.input = "textarea";
    this.init();
  }  
}
if (!window.customElements.get("input-area")) {
  window.customElements.define("input-area", InputArea);
}

class InputCheckbox extends Input {
  
  constructor() {
    super();
    this.selectors.group = "input";
    this.init();
  }

  setEvents = () => {
    this.getMessages();
    this.getValidators();
    this.input.addEventListener("change", () => {
      this.validate();
      // WCAG 3.2.2: per i radio NON inviare sul 'change' — con le frecce la selezione
      // cambia ad ogni spostamento e causerebbe un riordino/submit prematuro. I radio
      // inviano solo su azione deliberata (click/Spazio/Invio), gestita sotto.
      if(this.dataset.autosubmit != undefined && this.input.type !== 'radio') {
        this.form.handleSubmit();
      }
    });
    if(this.dataset.autosubmit != undefined && this.input.type === 'radio') {
      this.input.addEventListener("click", () => this.form.handleSubmit());
      this.input.addEventListener("keydown", (e) => {
        if(e.key === 'Enter') {
          e.preventDefault();
          this.form.handleSubmit();
        }
      });
    }
  }

  isEmpty = () => {
    return !this.input.checked;
  }
}
if (!window.customElements.get("input-checkbox")) {
  window.customElements.define("input-checkbox", InputCheckbox);
}

class InputPassword extends Input {
  tips; eye;
  
  constructor() {
    super();
    this.tips = this.querySelector("password-tips");
    this.eye = this.querySelector('password-eye');
    this.selectors.passwordEye = "[data-password-eye]";
    this.init();
  }

  setEvents = () => { 
    this.getMessages();
    this.getValidators();
    
    this.input.addEventListener("blur", () => {
      this.validate();
      if(this.tips != undefined)
        this.tips.hide();
    });

    this.input.addEventListener("focus", () => {
      this.setValid(true);
      if(this.tips != undefined)
        this.tips.show();
    });

    if(this.tips != undefined){
      this.input.addEventListener("input", () => {
        this.tips.checkPoints(this.input.value);
      });
    }

    if(this.eye != undefined){
      this.eye.addEventListener(Utils.E_PASSWORDEYE_SHOWN, () => {
        this.input.type = "text";
      });

      this.eye.addEventListener(Utils.E_PASSWORDEYE_HIDDEN, () => {
        this.input.type = "password";
      });
    }
  }

}
if (!window.customElements.get("input-password")) {
  window.customElements.define("input-password", InputPassword);
}

class PasswordTips extends HTMLElement {
  static classes = {
    hidden: "d-none",
    valid: 'valid',
    allValid: 'alert-success',
    someInvalid: 'alert-info'
  };
  points;
  
  constructor() {
    super();
    this.init();
  }

  init = () => { 
    this.points = this.querySelectorAll("[data-pattern]");
  }

  checkPoints = (value) => {
    this.points.forEach(point => {
      let pattern = new RegExp(point.dataset.pattern);
      if (pattern.test(value)) {
        point.classList.add(PasswordTips.classes.valid);
      } else {
        point.classList.remove(PasswordTips.classes.valid);
      }
    });
    this.setValid();
  }

  setValid = () => {
    const valid = this.querySelectorAll(`[data-pattern].${PasswordTips.classes.valid}`).length;
    const total = this.points.length;
    if(valid === total){
      this.classList.add(PasswordTips.classes.allValid);
      this.classList.remove(PasswordTips.classes.someInvalid);
    } else {
      this.classList.add(PasswordTips.classes.someInvalid);
      this.classList.remove(PasswordTips.classes.allValid);
    }
  }

  show = () => {
    this.classList.remove(PasswordTips.classes.hidden);
  }

  hide = () => {
    this.classList.add(PasswordTips.classes.hidden);
  }
}
if (!window.customElements.get("password-tips")) {
  window.customElements.define("password-tips", PasswordTips);
}

class PasswordEye extends HTMLElement {
  open; close; shown;
  static selectors = {
    open: '.open',
    close: '.close'
  };
  static classes = {
    hidden: "d-none"
  };
  
  constructor() {
    super();
    this.init();
  }

  init = () => { 
    this.open = this.querySelector(PasswordEye.selectors.open);
    this.close = this.querySelector(PasswordEye.selectors.close);
    this.shown = false;

    this.addEventListener("click", () => {
      this.toggle();
    });
  }

  toggle = () => {
    this.shown ? this.hide() : this.show();
  }

  show = () => {
    this.open.classList.add(PasswordEye.classes.hidden);
    this.close.classList.remove(PasswordEye.classes.hidden);
    this.shown = true;
    this.dispatchEvent(new CustomEvent(Utils.E_PASSWORDEYE_SHOWN));
  }

  hide = () => {
    this.open.classList.remove(PasswordEye.classes.hidden);
    this.close.classList.add(PasswordEye.classes.hidden);
    this.shown = false;
    this.dispatchEvent(new CustomEvent(Utils.E_PASSWORDEYE_HIDDEN));
  }

}
if (!window.customElements.get("password-eye")) {
  window.customElements.define("password-eye", PasswordEye);
}

class InputPlaces extends Input {
  search; 
    
  constructor() {
    super();
    this.selectors.input = "input";
    this.init();
  }

  setEvents = () => { 
    this.search = new google.maps.places.SearchBox(this.input);
    this.getMessages();
    this.getValidators();
    
    this.search.addListener('places_changed', () => {
      const places = this.search.getPlaces();
      this.dispatchEvent(new CustomEvent(Utils.E_PLACES_CHANGED, { detail: places }));
      Shopify.analytics.publish(Utils.E_PLACES_CHANGED, {
        name: places[0].name,
        formatted_address: places[0].formatted_address
      });
    });
  }

  getPlaces = () => {
    return this.search.getPlaces();
  }

  setBounds = (bounds) => {
    this.search.setBounds(bounds);
  }
}
if (!window.customElements.get("input-places")) {
  window.customElements.define("input-places", InputPlaces);
}

class InputPlacesGeolocator extends HTMLElement {
  
  constructor() {
    super();
    this.init();
  }

  init = () => {
    this.addEventListener("click", () => {
      this.locate();
    });
  }

  locate = () => {    
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        window.dispatchEvent(new CustomEvent(Utils.E_PLACES_GEOLOCATED, { detail: position }));
      });
    }
  }
}
if (!window.customElements.get("input-places-geolocator")) {
  window.customElements.define("input-places-geolocator", InputPlacesGeolocator);
}